module.exports = __webpack_public_path__ + "h5/img/orderIcon.cae46781.png";